import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { EmployerForm } from "../components/Forms";
import { TrustBar, ProcessTimeline, Ribbon } from "../components/Sections";
import { Seo, breadcrumbSchema } from "../components/Seo";

const SCHEMA = breadcrumbSchema([["Home", "/"], ["For Employers", "/employers"]]);

export default function Employers() {
  return (
    <>
      <Seo
        title="For Employers — Hire IT & Non-IT Talent"
        description="Submit a hiring requirement and our recruitment specialists will help you identify, evaluate and connect with the right IT and Non-IT professionals."
        keywords="Hire IT Professionals, Staffing Partner India, Recruitment Services for Employers, Contract Staffing Company"
        schema={SCHEMA}
      />
      <PageHeader kicker="For Employers" title="Need the Right Talent?"
        sub="Tell us what you're looking for. Our recruitment specialists will help you identify, evaluate and connect with the right professionals." />

      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-testid="employer-section">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <h2 className="text-2xl md:text-3xl font-bold text-navy">Submit a Hiring Requirement</h2>
              <p className="mt-4 text-ink leading-relaxed">Share your role, skills and timelines. We'll respond with a sourcing plan and relevant, pre-screened candidates.</p>
              <ul className="mt-6 space-y-3 text-navy font-medium">
                <li>· Dedicated recruitment specialist</li>
                <li>· Pre-screened, relevant shortlists</li>
                <li>· Transparent, regular updates</li>
                <li>· IT & Non-IT coverage</li>
              </ul>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8">
                <EmployerForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <Ribbon />
      <TrustBar />
      <ProcessTimeline />
    </>
  );
}
